import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { PagedApiResponse } from "../../utils/types/shared/_paged-api-response.type";
import { SAT_ENDPOINTS } from "../../components/mediaManager/campanias/sat/sat-endpoints";
import { Observable } from "rxjs";

import { FilterType } from "../../utils/types/shared/_filter.type";
import { SatMapper } from "../../utils/mappers/sat/sat.mapper";
import { Sat } from "../../utils/types/sat/sat.type";
import { BaseApiService } from "../shared/base.api.service";
import { KeyValue } from "../../utils/types/shared/keyvalue.type";
import { SharedCatalogMapper } from "../shared/sharedcatalog.service";
import { BaseMapper } from "../../utils/mappers/shared/base.mapper";

import { environment as env } from "../../../environments/environment";
import { SatDTO } from "../../utils/types/sat/satDTO.type";
import { AuthenticationService } from "../security/authentication.service";
import { SatInstantDTO } from "../../utils/types/sat/satInstantDTO.type";
import { User } from "../../utils/types/security/user.type";

import * as moment from "moment";
import { map } from "rxjs/operators";
import { SharedMapper } from "../../utils/mappers/shared/_shared.mapper";

@Injectable()
export class SatService {
    model = Sat;
    mapper: SatMapper = new SatMapper();
    apiEndPoint: any = SAT_ENDPOINTS;

    constructor(
        protected http: HttpClient,
        public sharedMapper: SharedMapper
    ) {}

    getList(filter?: FilterType): Observable<PagedApiResponse<Sat>> {
        /*  const id = AuthenticationService.getCurrentUserInformation().id;

              return this.http.get(this.apiEndPoint.list.replace('{userId}', id.toString()).replace('{limit}', filter.pageSize.toString()).replace('{offset}', filter.page.toString())).map(res => {
                  return this.mapper.mapPagedApiResponse(res, this.mapper.mapList, this.model);

              }); */

        return this.http.post(this.apiEndPoint.list, filter).pipe(
            map((res) => {
                return this.mapper.mapPagedApiResponse(
                    res,
                    this.mapper.mapList,
                    this.model
                );
            })
        );
    }

    delete(id: number): Observable<boolean> {
        return this.http
            .delete(this.apiEndPoint.item.replace("{id}", id.toString()), {
                observe: "response",
            })
            .pipe(
                map((res) => {
                    if (res.status === 200) {
                        return true;
                    }
                    return false;
                })
            );
    }

    create(data: SatInstantDTO): Observable<boolean> {
        /*  const userData: User = BaseMapper.map(AuthenticationService.getCurrentUserInformation(), User ) ;

        data.user = new User();

        data.user.active = userData.active;
        data.user.firstName = userData.firstName;
        data.user.id = userData.id;
        data.user.lastName = userData.lastName;
        data.user.organizationId = userData.organizationId;
        data.user.roles = userData.roles;
        data.user.username = userData.username;
        */
        return this.http.post<boolean>(this.apiEndPoint.baseInstant, data).pipe(
            map((res) => {
                return res;
            })
        );
    }

    createProgramado(data: SatDTO): Observable<boolean> {
        /*   const userData: User = BaseMapper.map(AuthenticationService.getCurrentUserInformation(), User ) ;
           data.id_user = userData.id;
           data.user = new User();

           data.user.active = userData.active;
           data.user.firstName = userData.firstName;
           data.user.id = userData.id;
           data.user.lastName = userData.lastName;
           data.user.organizationId = userData.organizationId;
           data.user.roles = userData.roles;
           data.user.username = userData.username;
   */
        data.execute_date = moment(data.execute_date).format("YYYY-MM-DD");
        data.execute_end_date = moment(data.execute_end_date).format(
            "YYYY-MM-DD HH:mm:ss"
        );

        return this.http
            .post<boolean>(this.apiEndPoint.baseProgramado, data)
            .pipe(
                map((res) => {
                    return res;
                })
            );
    }

    updateProgramado(data: SatDTO): Observable<boolean> {
        /*
          const userData: User = BaseMapper.map(AuthenticationService.getCurrentUserInformation(), User ) ;
          data.id_user = userData.id;
          data.user = new User();

          data.user.active = userData.active;
          data.user.firstName = userData.firstName;
          data.user.id = userData.id;
          data.user.lastName = userData.lastName;
          data.user.organizationId = userData.organizationId;
          data.user.roles = userData.roles;
          data.user.username = userData.username;
  */
        data.execute_date = moment(data.execute_date).format("YYYY-MM-DD");
        data.execute_end_date = moment(data.execute_end_date).format(
            "YYYY-MM-DD HH:mm:ss"
        );
        return this.http
            .put(this.apiEndPoint.baseProgramado, data, { observe: "response" })
            .pipe(
                map((res) => {
                    if (res.status === 200) {
                        return true;
                    }
                    return false;
                })
            );
    }

    get(id: Number): Observable<Sat> {
        return this.http
            .get(this.apiEndPoint.item.replace("{id}", id.toString()))
            .pipe(
                map((res) => {
                    return BaseMapper.map(res, this.model);
                })
            );
    }

    getIdNameOperatorList(): Observable<Array<KeyValue>> {
        const keyValueMapper = new SharedCatalogMapper();

        return this.http.get(this.apiEndPoint.idNames).pipe(
            map((res) => {
                return keyValueMapper.mapList(res, KeyValue);
            })
        );
    }

    getIdNameList(filter?: FilterType): Observable<PagedApiResponse<KeyValue>> {
        const keyValueMapper = new SharedCatalogMapper();

        return this.http.post(this.apiEndPoint.idNames, filter).pipe(
            map((res) => {
                return this.sharedMapper.mapPagedApiResponse<KeyValue>(
                    res,
                    keyValueMapper.mapList,
                    this.model
                );
            })
        );
    }

    getItemsIdNameList(
        vendorId: Number,
        filter?: FilterType
    ): Observable<PagedApiResponse<KeyValue>> {
        const keyValueMapper = new SharedCatalogMapper();

        return this.http
            .post(
                this.apiEndPoint.itemIdNames.replace(
                    "{id}",
                    vendorId.toString()
                ),
                filter
            )
            .pipe(
                map((res) => {
                    return this.sharedMapper.mapPagedApiResponse<KeyValue>(
                        res,
                        keyValueMapper.mapList,
                        KeyValue
                    );
                })
            );
    }

    getReportingData(id, filter): Observable<any> {
        return this.http
            .post<any>(
                this.apiEndPoint.getReportingData.replace("{id}", id),
                filter
            )
            .pipe(map((response) => response));
    }
}
